import { redirect } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";

import { firstScheduleAtom } from "@/lib/atoms/first-schedule-atom";
import { isFreeFollowUpPolicy } from "@/lib/form-schemas/first-schedule-appointment-types-schema";

const readDraft = () => getDefaultStore().get(firstScheduleAtom);

export const requireCreatedSchedules = (): void => {
  if (readDraft().codAgendas.length === 0) {
    redirect({ to: "/onboarding/first-schedule", replace: true, throw: true });
  }
};

export const requireFirstAppointmentDraft = (): void => {
  if (!readDraft().firstAppointment) {
    redirect({
      to: "/onboarding/first-schedule/first-appointment",
      replace: true,
      throw: true,
    });
  }
};

export const requireFreeFollowUpDraft = (): void => {
  if (!isFreeFollowUpPolicy(readDraft().followUp?.policy)) {
    redirect({ to: "/onboarding/first-schedule/follow-up", replace: true, throw: true });
  }
};

export const requireCompleteAppointmentTypesDraft = (): void => {
  const { firstAppointment, followUp } = readDraft();

  if (!firstAppointment || !followUp) {
    redirect({
      to: "/onboarding/first-schedule/first-appointment",
      replace: true,
      throw: true,
    });
    return;
  }

  if (isFreeFollowUpPolicy(followUp.policy) && !followUp.daysToFreeFollowUp) {
    redirect({
      to: "/onboarding/first-schedule/follow-up-days",
      replace: true,
      throw: true,
    });
  }
};
